import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import Switch from "../../components/Switch";
import useApiUrls from "../../useApiUrls";

const ShowCampaign = () => {
  const navigate = useNavigate();
  const { id, name } = useParams(); // Get the campaign ID from the URL

  const [data, setData] = useState([]); // Initialize as an empty array
  const [count, setCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [message, setMessage] = useState("");
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [dragResult, setDragResult] = useState(null);
  const { getUrlByOperation, error: urlError } = useApiUrls();

  // Fetch campaign data
  
  const fetchData = async () => {
    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const requestBody = {
      id: 0,
      campaignid: id,
      applycreateddate: false,
      fromcreateddate: 0,
      endcreateddate: 0,
      active: "",
      posname: "",
      merchantid: "",
      key: "",
      ispageload: false,
      pagesize: 1000,
      currentpageno: 0,
      withoutpagination: false,
      pagedirection: "",
    };

    try {
      const CampaignInfoSearch = getUrlByOperation("CampaignInfoSearch");
      const response = await axios.post(CampaignInfoSearch, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });

      if (response.data && Array.isArray(response.data.data)) {
        setData(response.data.data.sort((a, b) => a.position - b.position));
      } else {
        setData([]); 
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(); // Ensure fetchData is called on component mount
  }, [getUrlByOperation]);

  const handleSwitch = async () => {
    if (!dragResult || !dragResult.destination) return; // Check if dragResult is available

    setIsPopUpOpen(false);

    const reorderedItems = Array.from(data);
    const [movedItem] = reorderedItems.splice(dragResult.source.index, 1);
    reorderedItems.splice(dragResult.destination.index, 0, movedItem);

    // Update positions
    const updatedItems = reorderedItems.map((item, index) => ({
      id: item.id,
      position: index + 1,
    }));

    const requestBody = { list: updatedItems };

    try {
      // const localStorageData = JSON.parse(localStorage.getItem("user"));
      // const token = localStorageData?.token;
      // const userid = localStorageData?.userid;
      const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }
      const CampaignInfoUpdatePosition = getUrlByOperation("CampaignInfoUpdatePosition"); 

      await axios.post(
        CampaignInfoUpdatePosition,
        requestBody,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      setMessage("Positions updated successfully!");

      // Call fetchData again to refresh the list after switching
      fetchData();
    } catch (error) {
      console.error("Error updating positions:", error);
      setMessage("Failed to update positions.");
    }
  };

  const handleAddPop = () => {
    navigate(`/addImageincampagin/${id}/${name}`);
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    setDragResult(result); // Store the result in the state
    setIsPopUpOpen(true); // Open the confirmation popup
  };

  const handleImageClick = (image) => {
    setModalImage(image);
    setShowModal(true);
  };

  const handleToggle = async (e, item) => {
    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }
    const CampaignInfoActive = getUrlByOperation("CampaignInfoActive"); 
    const CampaignInfoDeactive = getUrlByOperation("CampaignInfoDeactive"); 
    const apiUrl = item.active
      ? CampaignInfoDeactive
      : CampaignInfoActive;

    const requestBody = { id: item.id };

    try {
      await axios.post(apiUrl, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      // Update the state to reflect the change
      setData(
        data.map((d) => (d.id === item.id ? { ...d, active: !item.active } : d))
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  const handlePosition = async (id, direction) => {
    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const requestBody = { id: id, direction: direction };


    try {
      const CampaignInfoSwitchPosition = getUrlByOperation("CampaignInfoSwitchPosition"); 
      await axios.post(CampaignInfoSwitchPosition, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      // fetchData();
      setMessage("Position updated successfully!");
      fetchData();
    } catch (error) {
      console.error("Error updating position:", error);
      setMessage("Failed to update position.");
    }
  };

  const handleUpdatePop = (id1) => {
    navigate(`/updateimageinfo/${id1}/${id}/${name}`);
  };

  const handleDelete = async (id) => {
    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const requestBody = { id: id };

   
    try {
      const CampaignInfoDelete = getUrlByOperation("CampaignInfoDelete"); 
      await axios.post(CampaignInfoDelete, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      // Refetch the data after delete to refresh the list
      setCount(count + 1);
      fetchData();
      setMessage("Data deleted successfully!");

      // fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
      setMessage("Failed to delete data");
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setModalImage("");
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000); // Clear the message after 3 seconds
      return () => clearTimeout(timer); // Cleanup the timer
    }
  }, [message]);

  // Rest of your component...

  return (
    <>
      {/* Rest of the component JSX */}
      <Menu />
      <div>
        <div className="wrapper">
          <div className="content-wrapper">
            <section className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h1 className="mb-0">Images</h1>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleAddPop}
                    >
                      Add Image
                    </button>
                  </div>
                </div>
              </div>
            </section>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className="card-body table-responsive p-0"
                  >
                    <section className="content">
                      <div className="container-fluid">
                        <hr />
                        <div className="row">
                          <div className="col-12">
                            <div className="card">
                              <div className="card-header"></div>

                              <div className="card-body table-responsive p-0">
                                <table className="table table-hover text-nowrap">
                                  <thead>
                                    <tr>
                                      <th>Id</th>
                                      <th>Campaign Image</th>
                                      <th>Position</th>
                                      <th>Image Description</th>
                                      <th>Active/Deactive</th>
                                      <th>Up/Down</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data.map((item, index) => (
                                      <Draggable
                                        key={item.id}
                                        draggableId={String(item.id)}
                                        index={index}
                                      >
                                        {(provided) => (
                                          <tr
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                          >
                                            <td>{item.id}</td>
                                            <td>
                                              <img
                                                src={item.filepath}
                                                alt="Campaign"
                                                style={{
                                                  width: "10%",
                                                  height: "10%",
                                                  objectFit: "cover",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  handleImageClick(
                                                    item.filepath
                                                  )
                                                }
                                              />
                                            </td>
                                            <td>{item.position}</td>
                                            <td>{item.remark}</td>
                                            <td>
                                            <Switch
                                    isOn={item.active}
                                    handleToggle={(e) => handleToggle(e, item)}
                                    id={item.id}
                                  />
                                            </td>
                                            <td>
                                              <button
                                                type="button"
                                                className="btn btn-success mr-2"
                                                onClick={(e) =>
                                                  handlePosition(item.id, "up")
                                                }
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="16"
                                                  height="16"
                                                  fill="currentColor"
                                                  className="bi bi-arrow-up"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <path
                                                    fillRule="evenodd"
                                                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5A.5.5 0 0 0 8 15z"
                                                  />
                                                </svg>
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={(e) =>
                                                  handlePosition(
                                                    item.id,
                                                    "down"
                                                  )
                                                }
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="16"
                                                  height="16"
                                                  fill="currentColor"
                                                  className="bi bi-arrow-down"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <path
                                                    fillRule="evenodd"
                                                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                                                  />
                                                </svg>
                                              </button>
                                            </td>
                                            <td>
                                              <button
                                                type="button"
                                                className="btn btn-info mr-2"
                                                onClick={() =>
                                                  handleUpdatePop(item.id)
                                                }
                                              >
                                                Update
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() =>
                                                  handleDelete(item.id)
                                                }
                                              >
                                                Delete
                                              </button>
                                            </td>
                                          </tr>
                                        )}
                                      </Draggable>
                                    ))}

                                    {provided.placeholder}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            {showModal && (
              <div
                className="modal"
                style={{
                  display: "block",
                  position: "fixed",
                  zIndex: 1050,
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                  outline: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                }}
                onClick={closeModal}
              >
                <div
                  className="modal-dialog modal-lg"
                  style={{
                    maxWidth: "500px",
                    margin: "30px auto",
                    maxWidth: "300px",
                  }}
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Image Preview</h5>
                      <button
                        type="button"
                        className="close"
                        onClick={closeModal}
                      >
                        <span>&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <img
                        src={modalImage}
                        alt="Campaign"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={closeModal}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {isPopUpOpen && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            padding: "20px",
            backgroundColor: "white",
            boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
            zIndex: 1000,
          }}
        >
          <h2>Are you sure you want to switch the campaign?"</h2>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 14,
            }}
          >
            <button
              type="button"
              className="btn btn-info mr-2"
              onClick={handleSwitch}
            >
              Yes
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setIsPopUpOpen(false)}
            >
              No
            </button>
          </div>
        </div>
      )}

      {/* Other content */}
      {message === "Data deleted successfully!" ? (
         <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message === "Failed to delete data" ? (
        <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default ShowCampaign;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
